import React from 'react';
import { Heart, DollarSign, Sparkles } from 'lucide-react';

export default function Donate() {
  return (
    <div className="max-w-4xl mx-auto py-6 sm:px-6 lg:px-8">
      <div className="px-4 py-6 sm:px-0">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent flex items-center justify-center mb-4">
            <Heart className="w-10 h-10 mr-3 text-red-500 animate-pulse" />
            Support ClearCash
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Help keep ClearCash free and accessible for everyone. Your support helps us maintain the platform and add new features.
          </p>
        </div>

        <div className="glass-effect rounded-2xl p-8 mb-8 cyber-glow animate-fadeIn">
          <div className="flex items-center justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-green-500/20 rounded-2xl blur-2xl"></div>
              <img
                src="/image.png"
                alt="CashApp QR Code"
                className="relative w-64 h-64 rounded-2xl shadow-2xl"
              />
            </div>
          </div>

          <div className="text-center">
            <h2 className="text-2xl font-bold bg-gradient-to-r from-green-600 to-emerald-500 bg-clip-text text-transparent mb-4">
              Donate via Cash App
            </h2>
            <p className="text-slate-600 mb-6">
              Scan the QR code above or send directly to:
            </p>
            <div className="inline-flex items-center px-8 py-4 gradient-success text-white rounded-xl text-2xl font-bold shadow-lg cyber-glow-green">
              <DollarSign className="w-8 h-8 mr-2" />
              $OrieGoudge
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 max-w-3xl mx-auto">
          <div className="glass-effect rounded-xl p-6 text-center hover:scale-105 transition-all duration-300 animate-fadeIn">
            <Sparkles className="w-12 h-12 mx-auto mb-4 text-cyan-600" />
            <h3 className="text-lg font-bold text-slate-800 mb-2">Fund New Features</h3>
            <p className="text-sm text-slate-600">
              Your support enables us to develop and release new tools and capabilities
            </p>
          </div>

          <div className="glass-effect rounded-xl p-6 text-center hover:scale-105 transition-all duration-300 animate-fadeIn" style={{ animationDelay: '100ms' }}>
            <Heart className="w-12 h-12 mx-auto mb-4 text-red-500" />
            <h3 className="text-lg font-bold text-slate-800 mb-2">Show Your Love</h3>
            <p className="text-sm text-slate-600">
              Let us know you appreciate the work and want to see ClearCash thrive
            </p>
          </div>
        </div>

        <div className="glass-effect rounded-xl p-8 animate-fadeIn" style={{ animationDelay: '300ms' }}>
          <h2 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent mb-4">
            Why Support ClearCash?
          </h2>
          <div className="space-y-4 text-slate-700">
            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500 flex items-center justify-center text-white font-bold mr-4">
                1
              </div>
              <div>
                <h3 className="font-semibold text-slate-800 mb-1">100% Free to Use</h3>
                <p className="text-sm">
                  ClearCash will always remain free for everyone. No hidden fees, no subscriptions, no paywalls.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500 flex items-center justify-center text-white font-bold mr-4">
                2
              </div>
              <div>
                <h3 className="font-semibold text-slate-800 mb-1">Privacy First</h3>
                <p className="text-sm">
                  Your financial data is yours. We never sell your information or connect to your bank accounts.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500 flex items-center justify-center text-white font-bold mr-4">
                3
              </div>
              <div>
                <h3 className="font-semibold text-slate-800 mb-1">Constantly Improving</h3>
                <p className="text-sm">
                  We regularly add new features and improvements based on user feedback and requests.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500 flex items-center justify-center text-white font-bold mr-4">
                4
              </div>
              <div>
                <h3 className="font-semibold text-slate-800 mb-1">Built by Real People</h3>
                <p className="text-sm">
                  ClearCash is developed and maintained by people who care about helping others achieve financial clarity.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-slate-600 text-lg">
            Thank you for using ClearCash and considering supporting our mission!
          </p>
          <p className="text-slate-500 text-sm mt-2">
            Every donation, big or small, makes a real difference.
          </p>
        </div>
      </div>
    </div>
  );
}
